import { render, staticRenderFns } from "./Setbank.vue?vue&type=template&id=6073c35b&scoped=true"
import script from "./Setbank.vue?vue&type=script&lang=js"
export * from "./Setbank.vue?vue&type=script&lang=js"
import style0 from "./Setbank.vue?vue&type=style&index=0&id=6073c35b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../空降-sp-弯弯介绍的/kj-德语-源码/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073c35b",
  null
  
)

export default component.exports